<template>
  <div
    v-bind="$attrs"
    class="font-medium"
  >
    <slot />
  </div>
</template>